
import { computed, defineComponent } from 'vue'
import Hamburger from '@/components/Buttons/ButtonHamburger.vue'

import useTheme from '@/composables/useTheme'

export default defineComponent({
  name: 'NavTwo',
  components: {
    Hamburger,
  },
  setup() {
    const { currentTheme, currentMode } = useTheme()

    const buttonStyles = computed(() => {
      return [
        currentTheme.value.buttons.primary.bg,
        currentTheme.value.buttons.primary.text,
        currentTheme.value.buttons.primary.hoverBg,
        'transition ease-in-out duration-300',
      ]
    })

    return {
      currentMode,
      currentTheme,
      buttonStyles,
    }
  },
})
